import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from 'OpsCenter/app.constants';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

/**
 * author andre.pitombeira
 */
export default function destinationService($http, slugifyService, RESOURCES, DESTINATION_TYPES) {
  return {
    getDestination,
    getDestinationById,
    getDestinationChildren,
    updateDestination,
    reindexDestinations,
    addDestination,
    getBrowserUrlForDestination,
    getDestinationByIdV2,
  };

  function getDestination(destination) {
    return $http.get(RESOURCES.DESTINATION + '?browserUrl=' + destination);
  }

  function getDestinationById(destinationId, config) {
    return $http.get(RESOURCES.DESTINATION + '/' + destinationId, config);
  }

  function getDestinationByIdV2(destinationId) {
    return $http.get(RESOURCES.DESTINATION + '/' + destinationId, { headers: { 'X-Quandoo-ApiVersion': '2' } });
  }

  function getDestinationChildren(destinationId, params) {
    return $http.get(RESOURCES.DESTINATION + '/' + destinationId + '/children' + (params ? params : ''));
  }

  function updateDestination(destinationId, data) {
    return $http.put(RESOURCES.DESTINATION + '/' + destinationId, data);
  }

  function reindexDestinations() {
    return $http.post(RESOURCES.DESTINATION + '/reindex', {});
  }

  function addDestination(params) {
    return $http.post(RESOURCES.DESTINATION, params);
  }

  function getBrowserUrlForDestination(destinationName, destinationType, tree) {
    let prefix = '';

    if (destinationType.id >= DESTINATION_TYPES.DISTRICT.id) {
      const indexOfCityOnDestinationTree = 3;
      prefix = tree[indexOfCityOnDestinationTree].browserUrl;
    }

    return slugifyService.slugify(prefix + ' ' + destinationName);
  }
}

@Injectable()
/** @desc Migrated destination service class to handle destination logic **/
export class DestinationService {
  constructor(private http: HttpClient) {}

  /**
   * @desc Function to get a destination by search word
   * @param {string} destination - The search word for the destination
   * @return {Observable}
   */
  getDestination(destination: string): Observable<any> {
    return this.http.get(RESOURCES.DESTINATION + '?browserUrl=' + destination).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get a destination by id, passing config parameters
   * @param {string} destinationId - Id of the destination to be retrieved
   * @param {object} config - Config parameter for filtering
   * @return {Observable}
   */
  getDestinationById(destinationId: string, config: object): Observable<any> {
    return this.http.get(RESOURCES.DESTINATION + '/' + destinationId, config).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get a destination suggestion by name, passing name
   * @param {string} destinationName - name of the destination to be retrieved
   * @return {Observable}
   */
  getDestinationSuggestion(destinationName: string): Observable<any> {
    return this.http.get(RESOURCES.DESTINATION + '/suggestions?query=' + destinationName).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to retrieve children of destination objects by id and filter params
   * @param {string} destinationId - Id of the destination to be retrieved
   * @param {object} params - Filter parameters
   * @return {Observable}
   */
  getDestinationChildren(destinationId: string, params: object): Observable<any> {
    return this.http.get(RESOURCES.DESTINATION + '/' + destinationId + '/children' + (params ? params : '')).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to update a single destination
   * @param {string} destinationId - Id of the destination to be updated
   * @param {object} data - Data with which the destination should be updated
   * @return {Observable}
   */
  updateDestination(destinationId: string, data: object): Observable<any> {
    return this.http.put(RESOURCES.DESTINATION + '/' + destinationId, data).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to request a re-indexing of destinations
   * @return {Observable}
   */
  reindexDestinations(): Observable<any> {
    return this.http.post(RESOURCES.DESTINATION + '/reindex', {}).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to add a new destination
   * @param {object} params - Destination object to be added
   * @return {Observable}
   */
  addDestination(params: object): Observable<any> {
    return this.http.post(RESOURCES.DESTINATION, params).pipe(map(res => <any>res));
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/destination.service.ts